import React from 'react';
import { AlertCircleIcon, ChevronRightIcon } from 'lucide-react';
import { ActionItem } from '../types';
interface ActionRequiredPanelProps {
  items: ActionItem[];
}
export function ActionRequiredPanel({
  items
}: ActionRequiredPanelProps) {
  if (items.length === 0) return null;
  return <div className="bg-white rounded-lg shadow-sm border border-rose-200 overflow-hidden" data-id="element-5">
      <div className="bg-rose-50/80 px-4 py-3 border-b border-rose-100 flex items-center justify-between" data-id="element-6">
        <div className="flex items-center" data-id="element-7">
          <AlertCircleIcon className="h-4 w-4 text-rose-500 mr-2" data-id="element-8" />
          <h2 className="text-sm font-semibold text-rose-900" data-id="element-9">
            Action Required
          </h2>
        </div>
        <span className="inline-flex items-center justify-center rounded-full bg-rose-100 px-2 py-0.5 text-[10px] font-semibold text-rose-700" data-id="element-10">
          {items.length}
        </span>
      </div>

      <ul className="divide-y divide-slate-100" data-id="element-11">
        {items.map(item => <li key={item.id} className="px-4 py-3.5 hover:bg-slate-50/50 transition-colors" data-id="element-12">
            <div className="flex items-center justify-between gap-3" data-id="element-13">
              <div className="flex-1 min-w-0" data-id="element-14">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-15">
                  <div className={`h-1.5 w-1.5 rounded-full shrink-0 ${item.urgency === 'high' ? 'bg-rose-500' : 'bg-amber-500'}`} data-id="element-16" />
                  <h3 className="text-sm font-semibold text-slate-900 truncate" data-id="element-17">
                    {item.title}
                  </h3>
                  <span className="text-[10px] text-slate-400 whitespace-nowrap" data-id="element-18">
                    {item.createdAt}
                  </span>
                </div>
                <p className="text-xs text-slate-500 ml-3.5 truncate" data-id="element-19">
                  {item.description}
                </p>
              </div>
              <button className="shrink-0 inline-flex items-center justify-center rounded-lg bg-white px-2.5 py-1.5 text-xs font-medium text-blue-600 shadow-sm ring-1 ring-inset ring-blue-200 hover:bg-blue-50 transition-colors" data-id="element-20">
                Resolve
                <ChevronRightIcon className="ml-1 h-3 w-3" data-id="element-21" />
              </button>
            </div>
          </li>)}
      </ul>
    </div>;
}